module.exports = __webpack_public_path__ + "img/LOGO-22.42126c39.png";